import { EVENTS } from "./constants";
import { ActiveVehicle } from "./types";
import { FacetsFormComponent } from "@theme/facets";

function findCompatibleFilterKey(): string | null {
  for (const key of new URL(window.location.href).searchParams.keys()) {
    if (
      key.startsWith("filter.p.m.app--") &&
      key.endsWith(".compatible_vehicles")
    ) {
      return key;
    }
  }
  const input = document.querySelector<HTMLInputElement>(
    'input[name^="filter.p.m.app--"][name$=".compatible_vehicles"]',
  );
  return input?.name ?? null;
}

let isInitialVehicleEvent = true;

function updateFacets(data: ActiveVehicle) {
  console.debug("Active vehicle change:", data);

  const compatibleFilter = findCompatibleFilterKey();
  if (!compatibleFilter) return;

  const { nonVehicleId } = window.vehicleManager.vehicles;
  const vehicleId = data?.vehicle.id;

  // Generate new filtered URL
  const url = new URL(window.location.href);
  // The subscription below replays the last vehicle event on mount, which
  // isn't a real vehicle change, so the page param must survive that call.
  if (!isInitialVehicleEvent) {
    url.searchParams.delete("page");
  }
  isInitialVehicleEvent = false;
  url.searchParams.delete(compatibleFilter);

  if (vehicleId) {
    url.searchParams.append(compatibleFilter, String(vehicleId));
    url.searchParams.append(compatibleFilter, String(nonVehicleId));
  }

  // Find any facets form on the page
  const forms = document.querySelectorAll<FacetsFormComponent>(
    "facets-form-component",
  );
  forms.forEach((form) => {
    // Skip the view transition: this fires from the vehicle selector app, whose
    // own garage/slideout panel may still be open and would end up rendered
    // beneath the animated grid.
    form.updateFiltersByURL(url.toString(), true);
  });
}

// Initialize subscription once facets component is ready
customElements.whenDefined("facets-form-component").then(() => {
  window.vehicleManager.pubsub.subscribe(EVENTS.vehicleChange, updateFacets, {
    replayLast: true,
  });
});
